import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "gematik-error-dialog",
  styleUrls: ["gematik-error-dialog.component.scss"],
  standalone: false,
  template: `
    <h1 mat-dialog-title>An error has occurred!</h1>
    <div mat-dialog-content>
      <p *ngIf="data.status">
        <b>Status Code: {{ data.status }}</b>
      </p>
      <p>Something went wrong!</p>
      <p class="error-message">
        {{ data?.message }}
      </p>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button mat-dialog-close color="primary">Close</button>
    </div>
  `,
})
export class GematikErrorDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; status?: number },
  ) {}
}
